import { useAtomValue } from 'jotai';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router';
import 'react-toastify/dist/ReactToastify.css';
import logoutAction from '~/actions/logoutAction';

import { authStateAtom } from '~/state/auth';

const NavigationHooks = () => {
  const [delayed, setDelayed] = useState(false);
  const authState = useAtomValue(authStateAtom);
  const [hasRun, setHasRun] = useState(false);

  // This is a major hack. The problem is, that the atoms are not loading
  // properly as they are not async. Feel free to remove this, when that is
  // fixed.
  useEffect(() => {
    setTimeout(() => {
      setDelayed(true);
    }, 100);
  }, []);

  // Navigation effect on auth state
  useEffect(() => {
    if (!delayed) {
      return;
    }

    // We only di this check on initial page load - We don't want to interrupt user login.
    // This is an incredibly hacky way to do this. This entire system really needs to be updated
    // At least this would allow support for the public application sub pages (credit-application and prequal)
    if (hasRun) {
      return;
    }
    setHasRun(true);

    // We are definitely not authenticated, stop execution
    if (!authState) {
      return;
    }

    // apparently we are initially logged in on a public page - we log out
    logoutAction();
  }, [authState, delayed]);

  return null;
};

export default function Layout() {
  return (
    <>
      <NavigationHooks />
      <Outlet />
    </>
  );
}
